export default "__VITE_ASSET__CUtiwcZ7__"